
import {
  computed,
  defineComponent,
  useStore,
  ref,
} from '@nuxtjs/composition-api'
import { CookieConsent } from '~/assets/ts/CookieConsent'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  name: 'CookieConsentBanner',
  components: {},
  props: [],
  setup() {
    const store = useStore()
    const acredoCookieConsent = new CookieConsent(getCountryCode(), true)

    const showDetails = ref('')

    const showDialog = computed(() => store.getters['cookieConsent/showDialog'])

    return { acredoCookieConsent, showDialog, showDetails }
  },
})
